import { useSession } from 'next-auth/react';
import { useState, useEffect } from 'react';
import profileAPi from '~/services/profile.service';
import { maskCardNumber } from '~/utils/profile-helpers';

const useAuthentication = () => {
    const { status } = useSession();
    const isGuestUser = status === 'unauthenticated';
    const isCXPUser = status === 'authenticated';
    return { isGuestUser, isCXPUser };
};

const useOriginalDL = (isCXPUser = true) => {
    const [dl, setDL] = useState('');

    useEffect(() => {
        const fetchOriginalDL = async () => {
            if (isCXPUser) {
                profileAPi.getOriginalDriverLicense().then(response => {
                    if (response?.data) {
                        setDL(response?.data.number || '');
                    }
                });
            }
        };

        fetchOriginalDL();
    }, []);

    const maskedDL = maskCardNumber(dl);

    return { dl, maskedDL };
};

const useOriginalPhotoCard = (isCXPUser = true, photoCardUser: boolean) => {
    const [originalPhotoCard, setOriginalPhotoCard] = useState('');

    useEffect(() => {
        const fetchOriginalPhotoCard = async () => {
            if (isCXPUser && photoCardUser) {
                const response = await profileAPi.getOriginalPhotoCard();
                if (response?.data) {
                    setOriginalPhotoCard(response?.data.number || '');
                }
            }
        };

        fetchOriginalPhotoCard();
    }, []);

    const maskedOriginalPhotoCard = maskCardNumber(originalPhotoCard);

    return { originalPhotoCard, maskedOriginalPhotoCard };
};

export { useAuthentication, useOriginalDL, useOriginalPhotoCard };
